import React from 'react'
import * as R from 'ramda'
import { usePlace } from 'commons/usePlace'
import WarningEndPlan from 'app/components/WarningEndPlan'
import WarningPending from 'app/components/WarningPending'
import { Routes } from 'app/services/routeService/routeService'
import BillingOverviewNotification from 'app/components/BillingOverviewNotification'
import { PlanBillingProvider } from 'app/main/plansAndBilling/usePlanBillingContext'

export default function AlertWarning(props) {
  const { history } = props
  const planBill = usePlace()
  const isOnlyBillingPage = R.includes(history.location.pathname, [
    Routes.billingOverview(),
    Routes.usageSummary(),
    Routes.usageHistory(),
    Routes.billingchangePlan(),
    Routes.aiUsageLog(),
  ])

  return (
    <>
      <div>
        <WarningEndPlan {...props} />
      </div>
      <div>
        <WarningPending {...props} />
      </div>
      <div>
        <PlanBillingProvider>
          {!R.isEmpty(planBill) && isOnlyBillingPage && (
            <BillingOverviewNotification planBill={planBill} />
          )}
        </PlanBillingProvider>
      </div>
    </>
  )
}
